export const apiUrl: string | undefined = process.env.REACT_APP_API_URL;
export const authUrl: string | undefined = process.env.REACT_APP_AUTH_URL;
export const clientId: string | undefined = process.env.REACT_APP_CLIENT_ID;
export const redirectUrl: string | undefined = process.env.REACT_APP_REDIRECT_URI;

export const apiUrls: Record<string, Record<string, string>> = {
  adminInquiries: {
    createNewSupplement: '/admininquiries/createnewsupplement',
    deactivateSupplement: '/admininquiries/deactivatesupplement',
    ingredientsSearch: '/admininquiries/searchingredients',
    matchExisting: '/admininquiries/matchexisting',
    medicationResponse: '/admininquiries/medicationresponse',
    needsInfo: '/admininquiries/needsinfo',
    medicationNeedsInfo: '/admininquiries/medicationneedsinfo',
    searchInquiriesDivided: '/admininquiries/searchinquiriesdivided',
    searchSupplements: '/admininquiries/searchsupplements',
    sendResponse: '/admininquiries/sendresponse',
    medicationSendResponse: '/admininquiries/medicationsendresponse',
    supplementInquiryDetails: '/admininquiries/supplementinquirydetails',
    medicationInquiryDetails: '/admininquiries/medicationinquirydetails',
    upsertSupplementInquiryResponse: '/admininquiries/upsertsupplementinquiryresponse',
    submitMedication: '/admininquiries/submitmedication',
  },

  cannedResponses: {
    addCannedResponse: '/cannedresponses/addcannedresponse',
    deleteCannedResponse: '/cannedresponses/deletecannedresponse',
    getCannedResponsesByCategory: '/cannedresponses/getcannedresponsesbycategory',
  },

  dashboard: {
    getCategories: '/dashboard/getcategories',
    getResource: '/dashboard/getresource',
    getResourceDetails: '/dashboard/getresourcedetails',
    orgInfo: '/dashboard/orginfo',
  },

  globalMessage: {
    delete: '/globalmessage/delete',
    get: '/globalmessage/get',
    upsert: '/globalmessage/upsert',
  },

  ingredients: {
    create: '/ingredients/create',
    importCleanUpCSVFile: '/ingredients/importingredientscsvfile',
  },

  inquiries: {
    addSupplement: '/inquiries/addsupplement',
    create: '/inquiries/create',
    deleteDraft: '/inquiries/deletedraft',
    details: '/inquiries/details',
    removeSupplementInquiry: '/inquiries/removesupplementinquiry',
    response: '/inquiries/response',
    responseDetails: '/inquiries/responsedetails',
    medicationResponseDetails: '/inquiries/medicationresponsedetails',
    printViewData: '/inquiries/printviewdata',
    search: '/inquiries/search',
    shareInquiry: '/inquiries/shareinquiry',
    sharedInquiryData: '/inquiries/getsharedinquiry',
    submit: '/inquiries/submit',
    supplementViewed: '/inquiries/supplementviewed',
    addUserEnteredMedications: '/inquiries/adduserenteredmedication',
    removeMedicationInquiry: '/inquiries/removemedicationinquiry',
  },

  lookups: {
    adminDrugClasses: '/lookups/admindrugclasses',
    adminRiskLevels: '/lookups/adminrisklevels',
    adminSupplementInquiryStatuses: '/lookups/adminsupplementinquirystatuses',
    athleteGenders: '/lookups/athletegenders',
    athleteRoles: '/lookups/athleteroles',
    athleteRoleGroups: '/lookups/athleterolegroups',
    athleteSports: '/lookups/athletesports',
    cannedResponseCategories: '/lookups/cannedresponsecategories',
    drugClasses: '/lookups/drugclasses',
    inquiryStatuses: '/lookups/inquirystatuses',
    medicationSettings: '/lookups/medicationsettings',
    organizations: '/lookups/organizations',
    riskLevels: '/lookups/risklevels',
    supplementCategories: '/lookups/supplementcategories',
    supplementInquiryStatuses: '/lookups/supplementinquirystatuses',
    programCodes: '/lookups/programcodes',
    riskLevelsDescription: '/lookups/risklevelsdescription',
    warningTypes: '/lookups/warningtypes',
    risksupplementcategories: 'lookups/risksupplementcategories',
  },

  medications: {
    details: '/medications/details',
    importCSVFile: '/medications/importcsvfile',
    importSynonymsListCSVFile: '/medications/importsynonymscsvfile',
    search: '/medications/search',
  },

  oauth2: {
    token: '/oauth2/token',
  },

  organizations: {
    create: '/organizations/create',
    deactivate: '/organizations/deactivate',
    details: '/organizations/details',
    reactivate: '/organizations/reactivate',
    search: '/organizations/search',
    update: '/organizations/update',
  },

  programCodes: {
    create: '/programcodes/create',
    details: '/programcodes/details',
    update: '/programcodes/update',
  },

  supplements: {
    details: '/supplements/details',
    search: '/supplements/search',
    importCleanUpCSVFile: '/supplements/importsupplementscsvfile',
  },

  userEnteredSupplements: {
    addNote: '/userenteredsupplements/addnote',
    create: '/userenteredsupplements/create',
    details: '/userenteredsupplements/details',
    update: '/userenteredsupplements/update',
    settings: '/userenteredsupplements/userenteredsupplementimagesettings',
  },

  userProfile: {
    root: '/userprofile',
    loginComplete: '/userprofile/logincomplete',
    setup: '/userprofile/setup',
  },

  userEnteredMedications: {
    addNote: '/userenteredmedications/addnote',
    basicInfo: '/userenteredmedications/basicinfo',
    create: '/userenteredmedications/create',
    createInquiry: '/userenteredmedications/create-inquiry',
    medicationViewed: '/userenteredmedications/medicationviewed',
    update: '/userenteredmedications/update',
  },

  risksupplements: {
    importcsvfile: '/risksupplements/importcsvfile',
    search: '/risksupplements/search',
    details: '/risksupplements/details',
  },
};
